// Library Methods
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { Link } from "react-router-dom";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type AccountRegistrationType = {
  handleSelectNavbarOption: (option: {
    route: string;
    label: string;
    subRoutes?: Array<{ route: string; label: string }>;
  }) => void;
};

const AccountRegistration = ({
  handleSelectNavbarOption,
}: AccountRegistrationType) => {
  const { t } = useTranslation("operating-manual");

  const onClickUrl = useCallback(() => {
    handleSelectNavbarOption({
      route: "virtual-reality-device",
      label: `6. ${t("Virtual Reality (VR) Device")}`,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [handleSelectNavbarOption, t]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography>
        {t(
          "During signup, user emails will be requested for user accounts. These user accounts will receive an email upon setup. They will receive an automated email with instructions to set up and log in to their account. Once configured, use your web browser to access the portal at "
        )}
        <Link
          to="http://portal.retinalogik.ca/"
          target="_blank"
          style={{ color: "#0066CC", textDecoration: "underline" }}
        >
          portal.retinalogik.ca
        </Link>
        {". "}
        {t(
          "If you require more user account emails, please reach out to support@retinalogik.ca."
        )}
      </Typography>
      <Typography>
        {t(
          "Once you receive the VR device, you will need to connect it to the internet. You will only need to do this once, as long as the Wi-Fi credentials stay the same. To view instructions for connecting the VR unit to Wi-Fi, see the "
        )}
        <Link
          to="/knowledge-hub/operating-manual/virtual-reality-device"
          style={{ color: "#0066CC", textDecoration: "underline" }}
          onClick={onClickUrl}
        >
          {t("Set Up Wi-Fi")}
        </Link>{" "}
        {t("section of this manual.")}
      </Typography>
    </Box>
  );
};

export default AccountRegistration;
